export const sales_types = [
  { value: "Contracted", label: "Contracted" },
  { value: "Reserved", label: "Reserved" },
  { value: "Blocked", label: "Blocked" },
  { value: "EOI", label: "EOI" },
  { value: "Potential", label: "Potential" },
];

export const sale_categories = [
  { value: "Primary", label: "Primary" },
  { value: "Resale Buyer", label: "Resale Buyer" },
  { value: "Resale Seller", label: "Resale Seller" },
  { value: "Nawy Now", label: "Nawy Now" },
  { value: "Commercial Sale", label: "Commercial Sale" },
  { value: "Commercial Leasing", label: "Commercial Leasing" },
  { value: "Developer Commercial Sale", label: "Developer Commercial Sale" },
  { value: "Developer Resale", label: "Developer Resale" },
  { value: "Nawy Now Refinance", label: "Nawy Now Refinance" },
  { value: "Unlocked-Now", label: "Unlocked-Now" },
];
export enum SaleTypeNames {
  Reserved = "Reserved",
  Contracted = "Contracted",
  Blocked = "Blocked",
  EOI = "EOI",
  Potential = "Potential",
  Promise = "Promise",
}

export enum SalesStatuses {
  CONGRATS_ITS_A_SALE = "Congrats... It's a sale!",
  UNLOCKED_CONGRATS = "[Unlocked] Congrats",
  PROMISE_SALE = "Promise Sale",
  UNIT_BLOCKED = "Unit Blocked",
  UNIT_RESERVED = "Unit Reserved",
  EOI = "EOI",
}
